import React, { useEffect, useState, useRef } from 'react';
import {AlertCircle, X} from "react-feather";
import { Search } from 'react-feather';
import LoadSpinner from "../Common/LoadSpinner";
import { getProducts } from '../../services/api/admin';

const ProductSearch = ({ formik, name, onProductSelect, selectedProducts, onProductRemove, label }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResultProducts, setSearchResultProducts] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const searchRef = useRef(null);

    const {errors, touched} = formik;

    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            const products = await getProducts();
            if (products) {
                setAllProducts(products);
            }
            setLoading(false);
        };

        fetchProducts();
    }, []);

    const handleInputChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);

        if (value.length > 2) {
            const filteredProducts = allProducts.filter(product =>
                product.name.toLowerCase().includes(value.toLowerCase())
                && !selectedProducts.some(p => p.id === product.id)
            );
            setSearchResultProducts(filteredProducts);
            setIsOpen(true);
        } else {
            setSearchResultProducts([]);
            setIsOpen(false);
        }
    };

    const productSelect = (product) => {
        if (selectedProducts.length < 3 && !selectedProducts.some(p => p.id === product.id)) {
            onProductSelect(product);
            setSearchTerm('');
            setIsOpen(false);
        }
    };

    const handleOutsideClick = (event) => {
        if (searchRef.current && !searchRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    return (
        <div ref={searchRef} className="sl-relative">

            <span className="sl-font sl-font-medium sl-text-sm sl-text-gray-700">{label}</span>
            <div
                className={`sl-input sl-border-1 sl-shadow-xs sl-rounded-lg sl-w-fill-available sl-flex sl-mt-2 
                ${selectedProducts.length >= 3 ? 'sl-bg-gray-50' : ''}
                ${touched[name] && errors[name] ? 'sl-border-1 sl-border-solid sl-border-error-300 ' : ''}`}
            >
                <Search className="sl-icon sl-icon-leading sl-place-self-center sl-h-5 sl-w-5 sl-ml-2"/>
                <input
                    value={searchTerm}
                    onChange={handleInputChange}
                    className="sl-input sl-border-none sl-font sl-text-md sl-font sl-font-normal sl-text-md sl-p-0 sl-m-0 sl-h-11 sl-w-fill-available"
                    type="text"
                    placeholder="Search"
                    disabled={selectedProducts.length >= 3}
                />
                {touched[name] && errors[name] &&
                    <AlertCircle size={16} className="sl-text-error-500 sl-absolute sl-right-3-point-5 sl-top-3"/>}
            </div>
            {touched[name] &&
                <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm sl-font">{errors[name]}</span>}

            {loading && <LoadSpinner/>}
            {isOpen && searchResultProducts.length > 0 && (
                <ul
                    className="sl-absolute sl-z-10 sl-bg-white sl-shadow-md sl-rounded-md sl-max-h-40
                    sl-overflow-y-auto sl-border sl-border-gray-200 sl-w-full sl-mt-1"
                >
                    {searchResultProducts.map((product) => (
                        <li
                            key={product.id}
                            onClick={() => productSelect(product)}
                            className="sl-py-2 sl-px-4 sl-cursor-pointer hover:sl-bg-gray-100"
                        >
                            {product.name}
                        </li>
                    ))}
                </ul>
            )}
            <div className="sl-mt-4">
                {selectedProducts?.map((product) => (
                    <div
                        key={product.id}
                        className="sl-w-fit-content sl-display-inline-block-i sl-mr-2 sl-bg-gray-100 sl-rounded sl-p-2 sl-mt-2"
                    >
                        <div className="sl-flex sl-align-center">
                            <div
                                className="sl-font sl-px-2 sl-py-1 sl-white-space-nowrap">{product.name}</div>
                            <X className="sl-w-4 sl-h-4 sl-cursor-pointer"
                               onClick={() => onProductRemove(product.id)}/>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductSearch;
